module.exports = __webpack_public_path__ + "img/users.8debb24e.svg";